import React from 'react';
import { Card, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Course.css';

const Course = (props) => {
    console.log(props)
    const { name, Fees, Time, Weekly, duration, img } = props.course;
    return (

        <Col>
            <Card className='course-image'>
                <Card.Img variant="top" src={img} />
                <Card.Body>
                    <Card.Title className='text-primary'>{name}</Card.Title>
                    <Card.Text>
                        <h6>Duration: {duration}</h6>
                        <h6>Class Time: {Time}</h6>
                        <p>Weekly Classes:{Weekly}</p>
                        <h5>Admission Fee: {Fees}</h5>
                        <Link className='enroll-btn' to={`/enroll/${name}`}><button >Enrol Now</button></Link>
                    </Card.Text>
                </Card.Body>
            </Card>
        </Col>
    );
};

export default Course;